var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 1C19 0.447715 18.5523 0 18 0C17.4477 0 17 0.447715 17 1V2.58579L10.4367 9.14909C10.2946 8.7699 9.92881 8.5 9.5 8.5C8.94771 8.5 8.5 8.94772 8.5 9.5V11.5C8.5 12.0523 8.94771 12.5 9.5 12.5H11.5C12.0523 12.5 12.5 12.0523 12.5 11.5C12.5 11.0712 12.2301 10.7054 11.8509 10.5633L18.4142 4H20C20.5523 4 21 3.55228 21 3C21 2.44772 20.5523 2 20 2H19V1Z",
    fill: "#FEDE58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1C12.0382 1 13.9339 1.60975 15.5148 2.65679L13.3302 4.84138C12.3399 4.30474 11.2055 4 10 4C6.13401 4 3 7.13401 3 11C3 14.866 6.13401 18 10 18C13.866 18 17 14.866 17 11C17 9.79448 16.6953 8.66014 16.1586 7.66981L18.3432 5.48522C19.3902 7.06609 20 8.96183 20 11C20 16.5228 15.5228 21 10 21C4.47715 21 0 16.5228 0 11C0 5.47715 4.47715 1 10 1Z",
    fill: "#FEDE58"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6C10.6449 6 11.2612 6.12208 11.8272 6.34438L10.4383 7.7333C10.1585 7.58438 9.83908 7.5 9.5 7.5C8.39543 7.5 7.5 8.39543 7.5 9.5V11.5C7.5 12.6046 8.39543 13.5 9.5 13.5H11.5C12.6046 13.5 13.5 12.6046 13.5 11.5C13.5 11.1609 13.4156 10.8415 13.2667 10.5617L14.6556 9.17281C14.8779 9.73879 15 10.3551 15 11C15 13.7614 12.7614 16 10 16C7.23858 16 5 13.7614 5 11C5 8.23858 7.23858 6 10 6Z",
    fill: "#FEDE58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.4824ced4eacb09a99d559ae93ba7c6f6.svg";
export { ForwardRef as ReactComponent };